import { FC } from 'react';
import { IconChat } from '../IconChat';
import { MenuItemIcon } from '../../../components/SideBar/types';

export const IconChatSidebar: FC<MenuItemIcon> = ({ active }) => {
  if (!active) {
    return <IconChat />;
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.38569C0 3.07038 1.22364 2 2.72727 2H20V14.7237C20 16.039 18.7764 17.1093 17.2727 17.1093H6.15455C4.95909 17.1093 3.77909 17.46 2.83091 18.097L0 20V4.38569ZM4.11026 9.54062H4.02989C3.87598 9.61096 3.74272 9.73908 3.64801 9.90782C3.55329 10.0766 3.50171 10.2779 3.5 10.4848C3.5 10.754 3.58446 11.0123 3.73505 11.2027C3.88563 11.3931 4.09001 11.5 4.30297 11.5C4.67456 11.4757 5.03491 11.3314 5.34981 11.0808C5.6647 10.8302 5.92361 10.4817 6.10161 10.0686C6.37462 9.58125 6.4548 9.48987 6.58327 9.48987C6.71175 9.48987 6.80016 9.58125 7.07317 10.0686C7.24925 10.4815 7.50643 10.8302 7.82007 11.0809C8.1337 11.3317 8.49319 11.476 8.86377 11.5C9.23536 11.4757 9.59571 11.3314 9.91061 11.0808C10.2255 10.8302 10.4844 10.4817 10.6624 10.0686C10.9354 9.58125 11.0158 9.48987 11.1443 9.48987C11.2727 9.48987 11.3529 9.58125 11.6259 10.0686C11.8039 10.4817 12.0628 10.8302 12.3777 11.0808C12.6926 11.3314 13.053 11.4757 13.4246 11.5C13.7952 11.476 14.1546 11.3317 14.4683 11.0809C14.7819 10.8302 15.0391 10.4815 15.2152 10.0686L15.3757 9.79443C15.502 9.62469 15.6682 9.51079 15.8495 9.46954C15.8762 9.47455 15.9033 9.47455 15.9299 9.46954C16.0926 9.40725 16.2354 9.28134 16.3379 9.10984C16.4403 8.93834 16.4971 8.73011 16.5 8.51523C16.5 8.24597 16.4153 7.98776 16.2648 7.79737C16.1142 7.60698 15.91 7.5 15.697 7.5C15.3265 7.52404 14.967 7.6684 14.6533 7.91913C14.3397 8.16986 14.0825 8.51853 13.9064 8.93151C13.6334 9.41882 13.5611 9.51019 13.4246 9.51019C13.2881 9.51019 13.2079 9.41882 12.9349 8.93151C12.7588 8.51853 12.5014 8.16986 12.1878 7.91913C11.8741 7.6684 11.5148 7.52404 11.1443 7.5C10.7737 7.52404 10.4142 7.6684 10.1006 7.91913C9.78693 8.16986 9.52955 8.51853 9.35347 8.93151C9.08046 9.41882 8.99224 9.51019 8.86377 9.51019C8.73529 9.51019 8.65492 9.41882 8.38191 8.93151C8.20391 8.51838 7.9452 8.16986 7.6303 7.91925C7.31541 7.66864 6.95486 7.52427 6.58327 7.5C6.21269 7.52404 5.8534 7.6684 5.53977 7.91913C5.22613 8.16986 4.96875 8.51853 4.79267 8.93151L4.63211 9.20557C4.48891 9.38136 4.30702 9.49819 4.11026 9.54062Z"
          fill="currentColor"
        />
      </svg>
    </svg>
  );
};
